// import { BsFillCreditCardFill } from 'react-icons/bs';
// import { RiBankFill } from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { DragAndDrop } from './DragAndDrop';
// import ReactLoading from 'react-loading';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import { LiaTimesSolid } from 'react-icons/lia';
import { LoadingMode } from '../Components/LoadingMode';
import { getToken } from '../utils';

export const BankAccountDetails = ({ data }) => {
  const [showPaymentDetails, setShowPaymentDetails] = useState({});
  const [title, setTitle] = useState('');
  const [test, settest] = useState(false);
  // const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);
  //  const [input, setInput] = useState({ image: "" });
  // const [paymentDetails, setPaymentDetails] = useState([]);
  // const [showCxAccount, setCxShowAccount] = useState(false);
  // const [file, setFile] = useState(null);

  // const navigate = useNavigate();
  // const handleCancelShowBankDetails = () => {
  //   navigate('/transactionrequest');
  // };

  const userToken = getToken().token;

  const {
    handleHideBankDetails,
    bidChatAccepted,
    viewData,
    // handleOpenandCloseModal,
    // handleToast,
    file,
    setFile,
    input,
    setInput,
    handleSubmitPayment,
    isSubmittingPayment,
    paymentDetails,
    setPaymentDetails,
    // openModal,
    handleFileChange,
    selectedFiles,
  } = data;
  const userId = getToken()?.user.id;
  const transationId = viewData?.id;
  //get FX and local payment
  useEffect(() => {
    const getPayment = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/payments/cx`,
          {
            cx_id: transationId,
          },
          { headers: { Authorization: `Bearer ${userToken}` } }
        );

        setPaymentDetails(response.data);
        settest(true);
      } catch (error) {
        console.log('error', 'error in lv account');
      }
    };
    getPayment();
  }, [setPaymentDetails, transationId, userToken]);

  // submit proof
  // useEffect(() => {
  //   if (isSubmittingPayment) {
  //     console.log(isSubmittingPayment);
  //     const getPayment = async () => {
  //       try {
  //         const response = await axios.post(
  //           `${process.env.REACT_APP_BASE_URL}/payments/proof`,
  //           {
  //             payment_id: paymentId,
  //             cx_transaction_id: transationId,
  //             image: file !== null ? file : input.image,
  //           },

  //           {
  //             headers: {
  //               Authorization: `Bearer ${userToken}`,
  //               "Content-Type": "multipart/form-data",
  //             },
  //           }
  //         );
  //        handleToast("success", "Proof of payment submited successfully");
  //        handleOpenandCloseModal("close");
  //        setIsSubmittingPayment(false);

  //         console.log(response.data);
  //       } catch (error) {
  //         handleToast("error", "Failed to submit, please try again!");
  //         setIsSubmittingPayment(false);
  //         console.log(error, "error in lv account");

  //       }
  //     };
  //     getPayment();
  //   }
  // }, [userToken, isSubmittingPayment]);
  const paymentId = paymentDetails?.id;

  const localPaymentDetails = {
    cx_currency: (
      <div className='flex flex-row gap-2 items-center'>
        <img
          src={paymentDetails?.lv_account?.country?.flag}
          alt={paymentDetails?.lv_account?.currency?.name}
          className='w-5 h-[13px]'
        />

        <p>{paymentDetails?.lv_account?.currency?.name} </p>
      </div>
    ),
    bank_name: paymentDetails?.lv_account?.local?.bank_name,
    account_name: paymentDetails?.lv_account?.account_name,
    account_number: paymentDetails?.lv_account?.local?.account_number,
    transaction_fee: `${Math.ceil(
      paymentDetails?.bidder_commission
    ).toLocaleString()} ${paymentDetails?.lv_account?.currency?.symbol}`,
    // discount: `${Math.ceil(
    //   paymentDetails?.owner_commission
    // ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.lv_account?.currency?.symbol}`,
    penalty: `${Math.ceil(
      paymentDetails?.auth_user_penalty
    ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.lv_account?.currency?.symbol}`,
    total_amount: `${Math.ceil(
      paymentDetails?.grand_total
    )?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.lv_account?.currency?.symbol}`,
  };

  const foreignPaymentDetail = {
    cx_currency: (
      <div className='flex flex-row gap-2 items-center'>
        <img
          src={viewData?.quote_currency?.country?.flag}
          alt={paymentDetails?.cx_account?.currency?.name}
          className='w-5 h-[13px]'
        />

        <p>{paymentDetails?.cx_account?.currency?.name}</p>
      </div>
    ),
    bank_name: paymentDetails?.cx_account?.cx?.bank_name,
    account_name: paymentDetails?.cx_account?.account_name,
    iban_number: paymentDetails?.cx_account?.cx?.iban_number,
    swift_code: paymentDetails?.cx_account?.cx?.swift_code,
    bank_location: `${paymentDetails?.cx_account?.country?.name} ${paymentDetails?.cx_account?.cx?.bank_address}`,
    transaction_fee: `${Math.ceil(
      paymentDetails?.owner_commission
    ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.lv_account?.currency?.symbol}`,
    // discount: `${Math.ceil(
    //   paymentDetails?.owner_commission
    // ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.cx_account?.currency?.symbol}`,
    penalty: `${Math.ceil(
      paymentDetails?.auth_user_penalty
    ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${paymentDetails?.lv_account?.currency?.symbol}`,
    total_amount: `${Math.ceil(paymentDetails?.cx_amount)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${
      paymentDetails?.cx_account?.currency?.symbol
    }`,
  };

  // const handleSubmitPayment = () => {
  //   setIsSubmittingPayment(true);

  // };

  const trxTypeId = viewData?.transaction_type?.id;
  const BidChatOriginatorId = bidChatAccepted?.orginator?.id;
  useEffect(() => {
    if (test) {
      if (trxTypeId === 2 && BidChatOriginatorId === userId) {
        setShowPaymentDetails(foreignPaymentDetail);
        setTitle('FX ACCOUNT DETAILS');
      } else if (trxTypeId === 2 && BidChatOriginatorId !== userId) {
        setShowPaymentDetails(localPaymentDetails);
        setTitle('LOYALTYVIEW ACCOUNT DETAILS');
      } else if (trxTypeId === 1 && BidChatOriginatorId === userId) {
        setShowPaymentDetails(localPaymentDetails);
        setTitle('LOYALTYVIEW ACCOUNT DETAILS');
      } else if (trxTypeId === 1 && BidChatOriginatorId !== userId) {
        setShowPaymentDetails(foreignPaymentDetail);
        setTitle('FX ACCOUNT DETAILS');
      }
    }
  }, [BidChatOriginatorId, test, trxTypeId, userId]);

  return (
    <article className='w-full'>
      {!Object.keys(showPaymentDetails)?.length ? (
        <LoadingMode />
      ) : (
        <div className='w-full flex flex-col items-center gap-2'>
          <h2 className='w-full tracking-wider font-semibold text-p-bk'>
            {title}
          </h2>

          <ul className=' space-y-1 py-4 w-full text-sm'>
            {Object.keys(showPaymentDetails)?.map((key, index) => (
              <li
                className='flex flex-row justify-between py-[2px] px-4 bg-t-wh rounded-md'
                key={index}
              >
                <span className='text-s-bk'>
                  {key.split('_')[0].charAt(0).toLocaleUpperCase() +
                    key?.split('_')[0]?.slice(1)}{' '}
                  {key?.split('_')[1] && key?.split('_')[1]}
                </span>
                {showPaymentDetails[key]}
              </li>
            ))}
          </ul>
          <div class="text-red-500 text-xs">
            <p>Note: <span>{paymentDetails?.transaction_type?.id === 1 ? 'A penalty will be applied to your payment for any canceled transaction where the payment has been made or accepted by the other user. This penalty applies if the transaction has not yet passed the timeline within which no penalty would be charged.' : 'Penalty amount will be deducted from the exotic currency amount of your payment from LoyaltyView as accumulated penalties for previously canceled transactions.'}</span></p>
          </div>

          <div className=' flex flex-col gap-6 w-full'>
            <DragAndDrop
              paymentData={{
                transationId,
                paymentId,
                handleSubmitPayment,
                isSubmittingPayment,
                handleHideBankDetails,
                userToken,
                file,
                setFile,
                input,
                setInput,
                handleFileChange,
                selectedFiles,
              }}
            />
            <button
              type='button'
              className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-8 w-full py-2 disabled:bg-b-mct bg-b-mc rounded relative'
              disabled={isSubmittingPayment || !selectedFiles.length}
              onClick={handleSubmitPayment}
            >
              Payment Completed
              {isSubmittingPayment && <LoadingMode />}
            </button>
          </div>
        </div>
      )}
    </article>
  );
};
